import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

import Icon from "react-icons-kit/Icon";
import { suitcase } from "react-icons-kit/fa/suitcase";


import './index.scss';
import { ls } from "../../../locale";
import { PassengerBox } from "./PassengerBox";

export default function Baggages(props) {

  const { currencyCode, selection, onSelectBag, onClearBag } = props;

  const [serviceSelection, setServiceSelection] = useState(selection);

  useEffect(() => {
    setServiceSelection(props.selection)
  }, [props.selection])

  const rExtraPage = ls.t('ExtraPage');
  if (!rExtraPage.Baggage) return null;

  const rFlight = ls.t('Flight');

  return (
    <div className="baggage-selection row">
      {
        serviceSelection && serviceSelection.map((flight, index) => {
          return (
            <div key={index} className="trip col-md-12">
              <div className="tw-pb-2 tw-flex tw-flex-row tw-gap-2">
                <div>
                  <Icon icon={suitcase} size={54} className="sa-text-green tw-me-2" />
                </div>
                <div className="tw-flex tw-flex-col tw-justify-center">
                  <div className="tw-flex tw-flex-row tw-items-center">                    
                    <span className="tw-uppercase tw-text-lg sa-text-green">{rExtraPage.CheckedBaggage}</span>
                  </div>
                  <div>
                    <span className="tw-capitalize tw-text-lg">{index === 0 ? rExtraPage.Departure : rExtraPage.Return}
                      <span className="tw-px-1">{flight.originCity}</span>{rFlight.To}
                      <span className="tw-px-1">{flight.destinationCity}</span>
                    </span>
                    <span className="tw-text-gray-400">&nbsp;-&nbsp;
                      {dayjs(flight.departureDate).format("dddd DD MMMM YYYY")}
                    </span>
                  </div>
                </div>
              </div>
              { 
                flight.passengers.map((passenger, index) => {
                  return (
                    <PassengerBox key={passenger.id} 
                      passengerIndex={index} // the passenger index in the passengers list
                      passenger={passenger} 
                      currencyCode={currencyCode} 
                      onSelectBag={onSelectBag} 
                      onClearBag={onClearBag} 
                      flightId={flight.logicalFlightId}
                    />
                  )
                })                
              }


            </div>
          )
        })
      }
    </div>
  )
}




